module.exports = __webpack_public_path__ + "img/21.8461271d.jpg";